
import $ from 'jquery';
import filters from '@/filters';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  filters,
})
export default class UploadProgress extends Vue {

  // PROP

  @Prop({default: 'uploadProgress'}) private id: string;
  @Prop({default: 0}) private number: number;
  @Prop({default: 'Name'}) private name: string;
  @Prop({default: 'Nim'}) private nim: string;
  @Prop({default: 'Error'}) private error: string;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* METHOD */

}
